import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=2a282de6";
import script from "./Layout.vue?vue&type=script&lang=js";
export * from "./Layout.vue?vue&type=script&lang=js";
import style0 from "./Layout.vue?vue&type=style&index=0&id=2a282de6&prod&lang=less";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;